// Preview-only route for design QA / polish gate.
// Mirrors /promo-cards and /preview/invite-submitted patterns.
import {
  AvailabilityPickerScreen,
  type PickerDayGroup,
} from '../components/AvailabilityPickerScreen';

const at = (y: number, m: number, d: number, h: number, min = 0) =>
  new Date(y, m - 1, d, h, min).getTime();

const demoDays: PickerDayGroup[] = [
  {
    dayId: '2026-05-21',
    dayLabel: 'Tuesday, May 21',
    slots: [
      { id: 't1-dinner', startMs: at(2026, 5, 21, 18, 0),  endMs: at(2026, 5, 21, 19, 30), mealtag: 'Dinner', initialResponse: 'works' },
      { id: 't1-after',  startMs: at(2026, 5, 21, 19, 30), endMs: at(2026, 5, 21, 21, 0),  mealtag: 'After work', initialResponse: 'works' },
    ],
  },
  {
    dayId: '2026-05-22',
    dayLabel: 'Wednesday, May 22',
    slots: [
      { id: 't2-lunch', startMs: at(2026, 5, 22, 12, 0), endMs: at(2026, 5, 22, 13, 30), mealtag: 'Lunch', initialResponse: 'maybe' },
      { id: 't2-after', startMs: at(2026, 5, 22, 18, 30), endMs: at(2026, 5, 22, 20, 0), mealtag: 'After work' },
    ],
  },
  {
    dayId: '2026-05-25',
    dayLabel: 'Saturday, May 25',
    slots: [
      { id: 's1-brunch', startMs: at(2026, 5, 25, 11, 0), endMs: at(2026, 5, 25, 12, 30), mealtag: 'Brunch' },
      { id: 's1-coffee', startMs: at(2026, 5, 25, 15, 0), endMs: at(2026, 5, 25, 16, 30), mealtag: 'Afternoon coffee', initialResponse: 'cant' },
    ],
  },
];

export default function AvailabilityPickerPreview() {
  return (
    <div className="min-h-screen bg-[#FAF8FB]">
      <AvailabilityPickerScreen
        eventTitle="CatchUp with Alex"
        organizerName="Alex"
        roughWindowLabel="May 20 – May 26"
        locationLabel="Blue Bottle Coffee · 30 Rockefeller Plaza"
        peopleCount={4}
        peoplePileInitials={['M', 'J', 'S']}
        days={demoDays}
        smsConsent={{ maskedPhone: '(•••) •••‑1234', initialConsented: true }}
        onSubmit={(payload) => {
          // eslint-disable-next-line no-console
          console.log('[picker preview] submit', payload);
        }}
      />
    </div>
  );
}
